const SETTINGS = {
  closed: true,
};

export { SETTINGS };
